import z from 'zod';
import { mepRef40EventType } from '../constants/create-plan-stages/stage-7/mep-ref-40';
import { zPhone } from '@/common';

export const myEmergencyPlanRegisterFormSchema = z.object({
  eventType: z.enum(mepRef40EventType),
  name: z
    .string({ required_error: 'Name is required' })
    .min(2, 'Name must be at least 2 characters long')
    .max(30, 'Name cannot exceed 30 characters'),
  email: z.string({ required_error: 'Email is required' }).email(),
  phone: zPhone,
  suburb: z
    .string({ required_error: 'Suburb is required' })
    .min(2, 'Suburb must be at least 2 characters long')
    .max(50, 'Suburb cannot exceed 50 characters'),
  comments: z.string().max(200, 'Comments cannot exceed 200 characters').optional(),
});

export type MyEmergencyPlanRegisterFormSchema = z.infer<typeof myEmergencyPlanRegisterFormSchema>;
